// extracted by mini-css-extract-plugin
export default {"external":"a9O2w7","ticker":"b9O2w7"};